<template>
  <!-- <v-footer app class="pa-3" color="secondary"> -->
  <v-footer dark color="accent">
    <!-- <span>{{ now | moment("dddd, Do MMMM YYYY, HH:mm:ss") }}</span> -->
    <v-spacer></v-spacer>
    <v-btn
      v-for="(item, index) in buttons"
      :key="index"
      flat
      style="font-size: 12px"
      color="primary"
      small
      class="px-3 ma-0 hidden-sm-and-down"
      @click="goto(item.action)"
    >{{item.text}}</v-btn>
    <!-- <v-btn
      flat
      style="font-size: 12px"
      color="primary"
      small
      class="px-3 ma-0"
      @click="router.push('/')"
    >reklamačné podmienky</v-btn>
    <v-btn
      flat
      style="font-size: 12px"
      color="primary"
      small
      class="px-3 ma-0"
      @click="router.push('/')"
    >ochrana osobných údajov</v-btn>
    <v-btn
      flat
      style="font-size: 12px"
      color="primary"
      small
      class="px-3 ma-0"
      @click="router.push('/')"
    >cookies</v-btn>-->
    <span class="px-3" style="font-size: 12px">&copy; {{ new Date().getFullYear() }}</span>
  </v-footer>
</template>

<script>
export default {
  name: "BottomNavigation",
  data() {
    return {
      now: null,
      buttons: [
        { action: "/terms-and-conditions", text: "obchodné podmienky" },
        { action: "/return-policy", text: "reklamačné podmienky" },
        { action: "/gdpr", text: "ochrana osobných údajov" },
        { action: "/cookies", text: "cookies" }
      ]
    };
  },
  created() {
    // setInterval(() => this.now = new Date, 1000)
  },
  methods: {
    goto(action) {
      console.log(action);
      this.$router.push(action);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
